
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/tools/topic-discovery-tool",
      function () {
        return require("private-next-pages/app/tools/topic-discovery-tool.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/app/tools/topic-discovery-tool"])
      });
    }
  